var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95 4146 c-67 -29 -105 -106 -91 -181 9 -47 59 -102 104 -115 26 -8 785 -10 2474 -8 l2437 3 27 21 c53 39 69 71 69 134 0 63 -16 95 -69 134 l-27 21 -2447 2 c-2019 2 -2452 0 -2477 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 2546 c-67 -29 -105 -106 -91 -181 9 -47 59 -102 104 -115 26 -8 785 -10 2474 -8 l2437 3 27 21 c53 39 69 71 69 134 0 63 -16 95 -69 134 l-27 21 -2447 2 c-2019 2 -2452 0 -2477 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 946 c-67 -29 -105 -106 -91 -181 9 -47 59 -102 104 -115 26 -8 785 -10 2474 -8 l2437 3 27 21 c53 39 69 71 69 134 0 63 -16 95 -69 134 l-27 21 -2447 2 c-2019 2 -2452 0 -2477 -11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.4fec2e6096360402fa46386d6e4cc4cd.svg";
export { ForwardRef as ReactComponent };